import { signOut } from "aws-amplify/auth";
import { useCallback, useContext } from "react";
import { UserTypeContext } from "../contexts/UserTypeContext";
import { RoutePaths } from "../enumStrings";

export const useHandleLogout = () => {
  const {
    setters: { setUserType },
  } = useContext(UserTypeContext);

  const handleLogout = useCallback(async (): Promise<void> => {
    try {
      await signOut();
    } catch (error) {
      console.log(error);
    }

    sessionStorage.clear();

    setUserType(null);

    window.location.href = RoutePaths.login;
  }, [setUserType]);

  return handleLogout;
};
